import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-567ea309"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "app2" }
const _hoisted_2 = { class: "form" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { style: {"font-family":"Lucida Handwriting,cursive"} }, [
  /*#__PURE__*/_createElementVNode("b", null, "Login")
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, [
  /*#__PURE__*/_createTextVNode("Contesis "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("Latinoamerica")
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_6 = { class: "inputbox" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "User" }, "Usuario", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "bi bi-person",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6m2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0m4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4m-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664z" })
], -1))
const _hoisted_9 = { class: "inputbox" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "password" }, "Contraseña", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "bi bi-lock",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M8 1a2 2 0 0 1 2 2v4H6V3a2 2 0 0 1 2-2zm3 6V3a3 3 0 0 0-6 0v4a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2zM5 8h6a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1z" })
], -1))
const _hoisted_12 = { key: 0 }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "spinner-border spinner-border-sm gap-2",
  "aria-hidden": "true",
  style: {"margin-right":"5px"}
}, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { role: "status" }, [
  /*#__PURE__*/_createElementVNode("small", { style: {"vertical-align":"inherit"} }, [
    /*#__PURE__*/_createElementVNode("small", { style: {"vertical-align":"inherit"} }, "Cargando...")
  ])
], -1))
const _hoisted_15 = [
  _hoisted_13,
  _hoisted_14
]
const _hoisted_16 = {
  key: 0,
  class: "alert alert-danger d-flex align-items-center",
  role: "alert",
  style: {"position":"absolute","top":"75%"}
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "bi bi-exclamation-triangle-fill flex-shrink-0 me-2",
  viewBox: "0 0 16 16",
  width: "16",
  height: "16",
  "aria-label": "Danger"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z" })
], -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " El usuario o contraseña son incorrectos! ", -1))
const _hoisted_19 = [
  _hoisted_17,
  _hoisted_18
]

import { onMounted, ref } from 'vue';
import LoginService from '@/services/LoginService';
import { useRouter } from 'vue-router';
import { userGlobalStore } from '@/store/userGlobal';


export default /*#__PURE__*/_defineComponent({
  __name: 'PageLogin',
  setup(__props) {

let gUser = userGlobalStore()

const username = ref<string>('');
const password = ref<string>('');
let loading = ref('Acceso')
const router = useRouter();
const openA = ref(false)
const openL = ref(false)

const validation = async (): Promise<void> => {
  try {
    loading.value = '';
    openL.value = !openL.value

    const credential = new LoginService();
    // Espera a que la solicitud se complete y actualice la variable 'user'
    await credential.fetchByLogin(username.value, password.value);

    // Obtén el usuario después de que la solicitud se complete
    const user = credential.getMs();

    console.log(user.value)
    // Validación
    if (!!user.value && user.value.message === 'Autenticacion exitosa') {
      router.push('/PrinPage');
      gUser.setUser(user.value.nombre_usuario)
      console.log('Credenciales válidas');
    } else {
      openL.value = !openL.value
      loading.value = 'Acceso'
      if (openA.value == false) {
        openA.value = !openA.value
      }

    }
  } catch (error) {
    console.error('Error al realizar la validación:', error);
  }
};

onMounted(() => {
  //por si quiero poner algo antes cuando se monta la pagina
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((username).value = $event)),
          type: "text",
          required: "",
          id: "User",
          autocomplete: "off"
        }, null, 512), [
          [_vModelText, username.value]
        ]),
        _hoisted_7,
        _hoisted_8
      ]),
      _createElementVNode("div", _hoisted_9, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((password).value = $event)),
          type: "password",
          required: "",
          id: "password"
        }, null, 512), [
          [_vModelText, password.value]
        ]),
        _hoisted_10,
        _hoisted_11
      ]),
      _createElementVNode("button", {
        class: "btn btn-primary",
        onClick: _withModifiers(validation, ["prevent"])
      }, [
        _createTextVNode(_toDisplayString(_unref(loading)) + " ", 1),
        (openL.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, _hoisted_15))
          : _createCommentVNode("", true)
      ]),
      (openA.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_16, _hoisted_19))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})